import { render, staticRenderFns } from "./CheckableItem.vue?vue&type=template&id=42415a98&scoped=true&"
import script from "./CheckableItem.vue?vue&type=script&lang=js&"
export * from "./CheckableItem.vue?vue&type=script&lang=js&"
import style0 from "./CheckableItem.vue?vue&type=style&index=0&id=42415a98&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42415a98",
  null
  
)

export default component.exports